import * as React from 'react';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PageNames } from '../../../../utils/app-constants';
import { RoutingRouteList } from '../components/RoutingRouteList';
import '../../../../transportation/styles.scss';

export const RoutingDeliveriesScene = () => {

    return (<PageContent pageName={PageNames.TRANSPORTATION_PLANNING_DELIVERIES}>
            <PageBody>
                <RoutingRouteList />
            </PageBody>
        </PageContent>);

};
